// extracted by mini-css-extract-plugin
module.exports = {"dashed":"dd31006766--dashed--SBZdI","popup-text":"dd31006766--popup-text--miW2D"};